import gql from 'graphql-tag';
import { AdminPromotionCategoryAllData } from '../fragments';

export default gql`
query AdminPromotionCategoryList($promotion_places: [PromotionPlace!]) {
    adminPromotionCategories(promotion_places: $promotion_places) {
        ...AdminPromotionCategoryAllData
    }
}
${AdminPromotionCategoryAllData}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/queries/adminPromotionCategoryList.ts